import HeaderBar from './HeaderBar';
import './HeaderBar.scss';

export default HeaderBar;